import React from "react";

const FooterMain = () => {
  return (
    <div className="footer-main">
      Copyright &#169; 2014 Architectect Co., Ltd. All rights reserved
    </div>
  );
};

export default FooterMain;
